export enum TextDesignClass {
  DEFAULT = 'w-full',
  FOURTEEN = 'w-14rem',
  SLIDE_TITLE = 'w-full medsurf-slide-title',
  SLIDE_CAPTION = 'w-full medsurf-slide-caption'
}